<template>
    <v-card style="margin-top: 20px;" id="codeInstall">
        
        <v-card-title class="text_primary">
            <v-icon left class="text_primary">
                mdi-cog
            </v-icon>
                {{ `設定` }}
            <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text >

            <v-container fluid>
            
                <v-row>

                    <v-col
                        cols="12"
                        class="d-flex justify-space-between align-center"
                        
                    >   
                        <div>
                            <v-card-subtitle :style="{color: 'black'}" >
                                <v-icon
                                    left
                                >
                                    mdi-wrench-outline
                                </v-icon>
                                    代碼安裝狀態
                            </v-card-subtitle>
                            <v-card-text v-if="container && container.is_installed === false">
                                {{ validate_text }}
                            </v-card-text>
                            <v-card-text v-else>
                                <v-alert
                                    type="success"
                                    dense
                                >
                                    已在網站上偵測Optimize99代碼
                                </v-alert>
                            </v-card-text>
                        </div>

                        <div>

                            <v-btn
                                @click="open_script_dialog"
                                color="#5087e6"
                                class="white--text"
                            >
                                {{ `安裝/檢查代碼` }}  
                            </v-btn>

                            <!-- <v-btn
                                class="ml-4"
                                :style="{
                                    color: 'rgb(26,115,232)',
                                    backgroundColor: '#fff',
                                    borderRadius: '3px',
                                }"
                                @click="checkInstall"
                            >
                                {{ `檢查安裝狀態` }}
                            </v-btn> -->

                        </div>
                        
                    </v-col>

                    <!-- <v-col
                        cols="12"
                        class="d-flex justify-space-between align-end"
                        style="border-bottom: 1px solid #ddd"
                    >   
                        <div>
                            <v-card-subtitle :style="{color: 'black'}">
                                <v-icon
                                    left
                                >
                                    mdi-email-outline
                                </v-icon>
                                    電子郵件通知
                            </v-card-subtitle>
                            <v-card-text v-model="email_notify_text">
                                {{ email_notify_text }}
                                
                            </v-card-text>
                        </div>

                        <div>

                            <v-switch
                                v-model="isOpenEmailNotify"
                                
                                :color="$vuetify.theme.themes['dark']['primary']"
                            ></v-switch>

                        </div>
                        
                    </v-col> -->

                    <!-- <v-col
                        cols="12"
                        class="d-flex justify-space-between align-end"
                        style="border-bottom: 1px solid #ddd"
                    >   
                        <div>
                            <v-card-subtitle :style="{color: 'black'}">
                                <v-icon
                                    left
                                >
                                    mdi-account-multiple-outline
                                </v-icon>
                                    流量分配
                            </v-card-subtitle>
                            <v-card-text v-model="traffic_distribute">
                                {{ traffic_distribute }}
                            </v-card-text>
                        </div>
  
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :style="{
                                        color: 'rgb(26,115,232)',
                                        backgroundColor: '#fff',
                                        borderRadius: '3px',
                                        boxShadow: 'none'
                                    }"
                                    @click="open_edit_traffic_distribute_dialog()"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="rate_btn"
                                >
                                    <span>
                                        {{ `${traffic_distribute_rate}%` }}
                                    </span>
                                    
                                    <v-icon
                                        right
                                    >
                                        mdi-pencil
                                    </v-icon>
                                    
                                </v-btn>
                            </template>
                            <span>編輯流量分配</span>
                        </v-tooltip>

                    </v-col> -->

                    <!-- <v-col
                        cols="12"
                        class="d-flex justify-space-between align-end"
                        
                    >
                        <div>
                            <v-card-subtitle :style="{color: 'black'}">
                                <v-icon
                                    left
                                >
                                    mdi-flash
                                </v-icon>
                                    啟用事件
                            </v-card-subtitle>
                            <v-card-text v-model="enable_event">
                                {{ enable_event }}
                            </v-card-text>
                        </div>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :style="{
                                        color: 'rgb(26,115,232)',
                                        backgroundColor: '#fff',
                                        borderRadius: '3px',
                                        boxShadow: 'none'
                                    }"
                                    @click="open_edit_enable_event_dialog"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="rate_btn"
                                >
                                    <span>
                                        {{ `${option_enable_event}` }}
                                    </span>
                                    
                                    <v-icon
                                        right
                                    >
                                        mdi-pencil
                                    </v-icon>
                                    
                                </v-btn>
                            </template>
                            <span>編輯啟用事件</span>
                        </v-tooltip>

                    </v-col> -->
                    
                </v-row>

            </v-container>
            
        </v-card-text>

        <InstallAbTestScriptDialog
            v-if="is_open_abtest_script"
            @closeScriptDialog="close_script_dialog"
            :containerId="$route.params.container_id"
            :check_url="experiment.url"
            @refreshContainerList="refreshContainer"
        />

        <DialogForm 
            v-if="is_open_traffic_distribute_dialog"
            :dialogSetting="dialog_setting"
            @submit="patch_traffic_distribute"
            @close="close_script_dialog"
        />

        <DialogForm 
            v-if="is_open_enable_event_dialog"
            :dialogSetting="enable_event_dialog_setting"
            @submit="patch_enable_event"
            @close="close_script_dialog"
        />

    </v-card>

</template>

<script>
import {
  apiGetContainer
} from '@/api/optimize.js'
import { mapGetters } from 'vuex'
// 代碼安裝說明彈窗
import InstallAbTestScriptDialog from "./InstallAbTestScriptDialog.vue";
import DialogForm from '@/components/Utils/DialogForm.vue'


export default {
    name: "Settings",
    props: {
        experiment: Object
    },
    components: {
        InstallAbTestScriptDialog,
        DialogForm
    },
    data() {
        return {
            validate_text: '尚未驗證。發布實驗前，請確認代碼已正確安裝 (必須)。',
            is_open_abtest_script: false,
            is_open_traffic_distribute_dialog: false,
            is_open_enable_event_dialog: false,
            email_notify_text: '接收有關實驗的重要通知。',
            isOpenEmailNotify: false,
            traffic_distribute: '符合參與此實驗資格的所有訪客所佔百分比。',
            traffic_distribute_rate: '100',
            dialog_setting: {
                title: '流量分配',
                fields: [
                    {
                        "id": "",
                        "label": "這可控制符合資格查看實驗的訪客百分比。注意：符合資格的訪客仍必須符合您的指定目標規則才能查看實驗。",
                        "value": 100,
                        "hint": "",
                        "type": "slider",
                        "max" : 100,
                        "min" : 0
                    }
                ],
                submit_text: '完成',
                submit_callback: 'submit',
                close_callback: 'close',
                views: null
            },
            enable_event: '選擇實驗的觸發時機。',
            option_enable_event: '載入網頁',
            enable_event_dialog_setting: {
                title: '啟用事件',
                fields: [
                    {
                        "id": "", //等Charles開好Api
                        "label": "",
                        "value": null,
                        "hint": "",
                        "type": "select",
                        "items": ['放入購物車','結帳數量','結帳金額','結帳訂單號碼']
                    }
                ],
                submit_text: '完成',
                submit_callback: 'submit',
                close_callback: 'close',
                views: null,
            },
            container: null
        }   
    },
    created: async function(){
        try {
            let container_id = this.$route.params.container_id
            let org_id = this.$route.params.org_id
            let result = await apiGetContainer(
                org_id, container_id 
            )
            this.container = result.data
        } catch (error) {
            this.$root.vtoast.show({ 
              message: `取得容器失敗，原因: ${ error.response ? (JSON.stringify(error.response)): error}`
            })
        }
    },
    methods: {
        open_script_dialog() {
            console.log("open");
            this.is_open_abtest_script = true
        },
        close_script_dialog() {
            console.log("close");
            this.is_open_abtest_script = false
            this.is_open_traffic_distribute_dialog = false
            this.is_open_enable_event_dialog = false
        },
        open_edit_traffic_distribute_dialog() {
            this.is_open_traffic_distribute_dialog = true
        },
        open_edit_enable_event_dialog() {
            this.is_open_enable_event_dialog = true
        },
        patch_traffic_distribute() {
            console.log('patch_traffic_distribute');
        },
        patch_enable_event() {
            console.log("patch_enable_event");
        },
        async refreshContainer(){
            try {
                console.log('refresh_container')
                let container_id = this.$route.params.container_id
                let org_id = this.$route.params.org_id
                let result = await apiGetContainer(
                    org_id, container_id 
                )
                this.container = result.data
                console.log('refresh_container', this.container)
                console.log('selectedContainer', this.selectedContainer)
                this.$store.commit('selected_container', this.container)
            } catch (error) {
                console.log('error', error)
            }
        }
    },
    computed: {
        ...mapGetters(['selectedOrg','selectedContainer']),
        selected_organize() {
        return this.$store.getters.selectedOrg
        }
    }
}
</script>

<style scoped>

    .rate_btn:hover{
        background-color: rgb(70, 143, 238);
    }

    /* Chrome, Safari, Edge, Opera */
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }


    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    input[type="number"]:hover,
    input[type="number"]:focus {
        -moz-appearance: number-input;
    }

</style>